<style lang="scss">
  @import '../resources/scss/locale_switcher.scss';
</style>

<script lang="ts">
  import { isLoading, locale } from 'svelte-i18n'
  import { useLocation, useNavigate } from 'svelte-navigator'
  import { routes, switchArray } from '../stores/stores'
  import { Constants } from '../config/constants'
  import { Slugs } from '../config/slugs'
  import { fallbackLocale, isLocale } from '../services/i18n'

  const location = useLocation()
  const navigate = useNavigate()
  export let mobile = false
  let url: string
  let lang: string
  let urlLang: string
  $: url = $location.pathname ?? ''
  $: lang = $locale ?? fallbackLocale
  $: urlLang = url.split(Constants.SLASH)[1] ? url.split(Constants.SLASH)[1] : lang

  function isIndividualNewDetailRoute(url: string, lang: string) {
    const routeIndividualNew =
      $routes.get(lang + Constants.DOUBLE_BARS + Slugs.Show_News) ?? ''
    const routeNews = $routes.get(lang + Constants.DOUBLE_BARS + Slugs.News) ?? ''
    return url.includes(routeNews) && url.includes(routeIndividualNew)
  }

  function isNewsRoute(url: string, lang: string) {
    const routeNews = $routes.get(lang + Constants.DOUBLE_BARS + Slugs.News) ?? ''
    return url === routeNews || url.startsWith(routeNews + Constants.SLASH)
  }

  function getRouteForNews(url: string, keySlug: string): string {
    let newsPageNumber: string = url.split(Constants.SLASH)[
      url.split(Constants.SLASH).length - 1
    ]
      ? url.split(Constants.SLASH)[url.split(Constants.SLASH).length - 1]
      : ''
    let r = `${lang}${Constants.DOUBLE_BARS}${keySlug}`
    let finalPath =
      $routes.get(r) ?? '' + Constants.SLASH.toString() + newsPageNumber.toString()
    return finalPath
  }

  function getRouteValueForNewDetails(url: string, keySlug: string): string {
    let newId = url.split(Constants.SLASH).pop() ?? ''
    let r = `${lang}${Constants.DOUBLE_BARS}${keySlug}`
    let routeShowNews = $routes.get(r) ?? ''
    let finalPath = `${
      $routes.get(r.replace(Slugs.Show_News, Slugs.News)) ?? ''
    }${routeShowNews}${Constants.SLASH}${newId}`
    return finalPath
  }

  let myAdd = function (newLang: string) {
    $locale = newLang
    if (url == Constants.SLASH) {
      navigate(`/${newLang}`)
      return
    }

    // need to update lang as we're inside an event
    lang = newLang

    let hrefPath: string | undefined
    for (const [key, value] of $routes) {
      let keySplit = key.split(Constants.DOUBLE_BARS)
      let keySlug = keySplit[keySplit.length - 1]
      if (
        keySlug === Slugs.News &&
        !isIndividualNewDetailRoute(url, urlLang) &&
        isNewsRoute(url, urlLang)
      ) {
        hrefPath = getRouteForNews(url, keySlug)
        break
      } else if (
        keySlug === Slugs.Show_News &&
        isIndividualNewDetailRoute(url, urlLang)
      ) {
        hrefPath = getRouteValueForNewDetails(url, keySlug)
        break
      } else if (url === value) {
        let a = `${lang}${Constants.DOUBLE_BARS}${keySlug}`
        hrefPath = $routes.get(a)
        break
      }
    }
    if (hrefPath) {
      navigate(hrefPath)
    }
  }

  $: {
    let newLocale = url.split(Constants.SLASH, 2)?.[1]
    if (isLocale(newLocale)) {
      $locale = newLocale
    } else {
      $locale = fallbackLocale
    }
  }

  function textToUpper(s: string) {
    let upper = s.toUpperCase() ? s.toUpperCase() : ''
    return upper
  }
</script>

{#if mobile}
  <ul class="locale-switcher list-inline d-inline-flex mb-0 py-2 px-2 gap-2">
    {#each $switchArray as lang, i}
      <li class="list-inline-item">
        <div
          class="dropdown-item h5 mb-0 p-1"
          class:first={i == 0}
          class:text-orange={i == 0}
          class:last={i === $switchArray.length - 1}
          on:click={() => i != 0 && myAdd(lang)}
        >
          {textToUpper(lang)}
        </div>
      </li>
    {/each}
  </ul>
{:else if $isLoading}
  <p>loading translations...</p>
{:else}
  <li class="nav-item">
    <div class="dropdown locale-switcher">
      <a
        class="nav-link h6 mb-0 text-primary-orange dropdown"
        href={'#'}
        id="navbarDropdown"
        role="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        {lang.toUpperCase()}
      </a>
      <ul class="dropdown-menu">
        {#each $switchArray as lang, i}
          {#if i === 0}
            <li>
              <div
                class="dropdown-item cursor-pointer h6 text-orange"
                on:click={() => myAdd(lang)}
              >
                {textToUpper(lang)}
              </div>
            </li>
          {:else}
            <li>
              <div class="dropdown-item cursor-pointer h6" on:click={() => myAdd(lang)}>
                {textToUpper(lang)}
              </div>
            </li>
          {/if}
        {/each}
      </ul>
    </div>
  </li>
{/if}
